module.exports = __webpack_public_path__ + "static/media/badge-sheriff.f90824f7.svg";